import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { View } from 'react-native'

export function EmptyAvailability() {
  const styles = useStyles()
  return (
    <View style={styles.container}>
      <Text style={styles.text}>{t('noAvailabilities')}</Text>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontSize: 16,
  },
}))
